export const Select = {
    name: 'Select',
    props: ['options', 'value', 'placeholder'],
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: e => {
                    this.$emit('input', e.target.value)
                }
            }
        },
    },
    template: `
        <select class="select" :value="value" v-bind="$attrs" v-on="listeners">
        <option value="" v-if="placeholder" disabled selected>{{placeholder}}</option>
        <slot></slot>
        </select>
    `
};